import { WorkflowServerWeb } from '@wix/ambassador-workflow-server-web/http';

export interface WorkflowServiceApi {
  cloneTemplate(id: string): any;
}

export class WorkflowService implements WorkflowServiceApi {
  private readonly workflowApi: ReturnType<typeof WorkflowServerWeb>;
  constructor(private readonly baseUrl: string, private readonly instance) {
    this.workflowApi = WorkflowServerWeb(this.baseUrl, {
      useRedAxios: true,
    });
  }

  private get headers() {
    return {
      authorization: this.instance,
    };
  }

  public async cloneTemplate(id: string) {
    return this.workflowApi
      .TemplatesService()(this.headers)
      .cloneTemplate({ id });
  }
}
